/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Versioned ranking policies accepted by the people-search APIs.
 */
export enum PeopleSearchRankingMode {
    PERSONALIZED_V1 = 'personalized_v1',
}
